exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".output-globals .row+.row{margin-top:0px}.output-globals .vertrag-value{flex:0 0 85px;white-space:nowrap}", ""]);

